import React, {useState, useEffect} from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom'; // Import useHistory

const API_URL = process.env.REACT_APP_API_URL;

const AuthContext = React.createContext();

function AuthProviderWrapper(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const history = useHistory(); // Initialize useHistory

  const verifyStoredToken = () => {
    // Get the stored token from the localStorage
    const storedToken = localStorage.getItem('authToken');

    // If the token exists in the localStorage
    if (storedToken) {
      // We must send the JWT token in the request's "Authorization" Headers
      axios
        .get(`${API_URL}/auth/verify`, {
          headers: {Authorization: `Bearer ${storedToken}`},
        })
        .then(response => {
          // If the server verifies that JWT token is valid  ✅
          const user = response.data;
          setUser(user);
          setIsLoggedIn(true);
          setIsLoading(false);
        })
        .catch(error => {
          // If the server sends an error response (invalid token) ❌
          console.error('Error verifying token:', error);
          setIsLoggedIn(false);
          setUser(null);
          setIsLoading(false);
          localStorage.removeItem('authToken'); // Remove the invalid token
          history.push('/home'); // Redirect to home page
        });
    } else {
      // If the token is not available
      setIsLoading(false);
    }
  };

  const logInUser = token => {
    localStorage.setItem('authToken', token.token);

    setUser(token.user);
    verifyStoredToken();
  };

  const logOutUser = () => {
    // Upon logout, remove the token from the localStorage
    localStorage.removeItem('authToken');

    // Update the state variables
    setIsLoggedIn(false);
    setUser(null);
  };

  useEffect(() => {
    verifyStoredToken();
  }, []);

  return (
    <AuthContext.Provider
      value={{isLoggedIn, isLoading, user, logInUser, logOutUser, setUser}}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

AuthProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export {AuthProviderWrapper, AuthContext};
